import { render } from "./ListSection.vue?vue&type=template&id=0b545809&ts=true"
import script from "./ListSection.vue?vue&type=script&lang=ts"
export * from "./ListSection.vue?vue&type=script&lang=ts"

import "./ListSection.vue?vue&type=style&index=0&id=0b545809&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__